// Fill in your Firebase credentials below
export const firebaseConfig = {
  apiKey: "AIzaSyBwf9iF4Wo-b_tHJMReqq2I6f6bCMy2JiI",
  authDomain: "interviewcodepad.firebaseapp.com",
  databaseURL: "https://interviewcodepad-default-rtdb.firebaseio.com/",
  projectId: "interviewcodepad",
  storageBucket: "interviewcodepad.firebasestorage.app",
  messagingSenderId: "193662718406",
  appId: "1:193662718406:web:c2050d48985e547b38e2c7",
  measurementId: "G-68GYT38V91"
}; 